import { Page } from '@dixa/lib-shared-habla';

import { Organization } from 'components/settings/organization/containers/organization';

export const SettingsOrganizationView = (): JSX.Element => {
  return (
    <Page>
      <Page.Head title="Organization" />

      <Page.Body>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <Organization />
      </Page.Body>
    </Page>
  );
};
